import { isNull, isBoolean } from 'util';

export interface RawRecording {
  backupIdentifiers: {
    iCloudFileIdentifier: string;
  };
  billDuration: number;
  callUUID: string;
  durationInMS: number;
  durationInSeconds: number;
  endTime: string;
  from: string;
  hangupCause: string;
  isPlayed: boolean;
  isRead: boolean;
  pricePerMinute: number;
  recordingId: string;
  recordingUrl: string;
  service: string;
  startTime: string;
  status: string;
  timestamp: number;
  title: string;
  to: string;
  totalCost: number;
  transcript: string;
}


export interface Recording extends RawRecording {
  appInfo: AppInfo;
}

interface AppInfo {
  dbKey: string;
  selected: boolean;
  sortInfo: {
    title: string;
    date: number;
    duration: number;
    comment: string;
  };
}

export enum RecordStatus {
  InProgress = 'recording',
  Recorded = 'recorded',
  Processing = 'hangup',
  Error = 'failed'
}

export class RecordingCl implements Recording {
  title = '';
  status = RecordStatus.Recorded;
  transcript = '';
  from = '+000000000000';
  to = '+000000000000';
  durationInMS = 0;
  durationInSeconds = 0;
  startTime = null;
  endTime = null;
  timestamp = 0;
  billDuration = 0;
  pricePerMinute = 0;
  totalCost = 0;
  recordingId = '0000000000';
  recordingUrl = 'https://s3.amazonaws.com/recordings_2013/d4f55956-42fe-11e8-aec2-02f6f257685a.mp3';
  isPlayed = false;
  isRead = false;
  backupIdentifiers = {
    iCloudFileIdentifier: '0000000000'
  };
  callUUID = '0000000000';
  hangupCause = 'NORMAL_CLEARING';
  service = 'plivo';
  appInfo = null;

  constructor(rawRecording, dbKey: string) {
    let absentFields: string[] = [];

    if (rawRecording) {
      for (const key in this) {
        if (rawRecording[key] || isBoolean(rawRecording[key])) {
          this[key] = rawRecording[key];
          absentFields = absentFields.filter(field => field !== key);
        } else {
          absentFields.push(key);
        }
      }
    }
    // Filter from our fields
    absentFields = absentFields.filter(field => field !== 'appInfo');
    absentFields = absentFields.filter(field => field !== 'addAppInfo');

    this.timestamp *= 1000;
    this.appInfo = this.addAppInfo(dbKey);

    if (absentFields.length) {
      // console.error('No such fields were present in the database response (default values used): ', absentFields.join(', '));
    }
  }

  private addAppInfo(dbKey: string): AppInfo {
    const appInfo: AppInfo = {
      dbKey,
      selected: false,
      sortInfo: {
        title: this.title,
        date: new Date(this.timestamp).getTime(),
        comment: this.transcript,
        duration: this.durationInMS
      }
    };

    if (this.timestamp && this.status !== RecordStatus.Recorded) {
      appInfo.sortInfo.date = new Date().getTime();
    }

    return appInfo;
  }
}



// WEBPACK FOOTER //
// ./src/app/data-models/recording.typings.ts